import { types, actions } from './requests'
export const SEARCH_TYPES = {
    ...types('SEARCH'),
}
export const SEARCH_ACTIONS = {
    ...actions('SEARCH'),
}
